// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3aht-","title":"Images45_title__3_O2u","images":"Images45_images__1zr0B"};